/**
 * 图片工具Vue插件
 * 全局注册图片相关的工具函数和配置
 */

import * as imageUtils from '../utils/imageUtils'
import imageConfig from '../config/images'

export default {
  install(Vue) {
    // 全局属性：图片工具函数
    Vue.prototype.$imageUtils = imageUtils
    
    // 全局属性：图片配置
    Vue.prototype.$images = imageConfig
    
    // 全局方法：获取图片URL
    Vue.prototype.$getImageUrl = imageUtils.getImageUrl
    
    // 全局方法：获取响应式图片URLs
    Vue.prototype.$getResponsiveImageUrls = imageUtils.getResponsiveImageUrls
    
    // 全局方法：获取加载中图片URL
    Vue.prototype.$getLoadingImageUrl = imageUtils.getLoadingImageUrl
    
    // 全局方法：批量获取图片URLs
    Vue.prototype.$getImageUrls = imageUtils.getImageUrls
    
    // 全局过滤器：图片URL转换
    Vue.filter('imageUrl', (imagePath) => {
      if (!imagePath) return ''
      return imageUtils.getImageUrl(imagePath)
    })
    
    // 全局过滤器：加载中图片URL转换
    Vue.filter('loadingImageUrl', (imagePath) => {
      if (!imagePath) return ''
      return imageUtils.getLoadingImageUrl(imagePath)
    })
  }
}